import { type ImporterSampleData } from '@webapp/platform/_unmigrated/Importer/types'
import { type CustomField, type Department } from '../../models'
import { CustomFieldTypes } from '../../models/enums/CustomField'

export * from './PDFLabelSet.factory'
export * from './QBOMapField.factory'
export * from './account.factory'
export * from './accountcode.factory'
export * from './additionalBillCost.factory'
export * from './apcreditcard.factory'
export * from './apcost.factory'
export * from './apiApplication.factory'
export * from './applicationStatus.factory'
export * from './approvalChain.factory'
export * from './approvalGroup.factory'
export * from './approver.mock'
export * from './approverCounts.factory'
export * from './attachment.factory'
export * from './bill.factory'
export * from './billingHistoryItem.factory'
export * from './billUnpaidSummary.factory'
export * from './budget.factory'
export * from './budgetCategory.factory'
export * from './catalogitem.factory'
export * from './comment.factory'
export * from './contenttype.factory'
export * from './contract.factory'
export * from './costallocation.factory'
export * from './creditcard.factory'
export * from './currency.factory'
export * from './customfield.factory'
export * from './department.factory'
export * from './expense.factory'
export * from './exportFormat.factory'
export * from './featureSwitches.factory'
export * from './fieldMapping.factory'
export * from './financialAccountMonthlySummary.factory'
export * from './financialAccountTransaction.factory'
export * from './global.factory'
export * from './inbox.factory'
export * from './inboxMessage.factory'
export * from './instanceManagementInstance.factory'
export * from './integrationResponse'
export * from './IntegrationEntitySyncConfiguration'
export * from './integrationStatus.factory'
export * from './integrationSyncLog.factory'
export * from './location.factory'
export * from './order.factory'
export * from './orderItem.factory'
export * from './payApproval.factory'
export * from './payCard.factory'
export * from './payCardTransaction.factory'
export * from './payCardholder.factory'
export * from './payEphemeralKey.factory'
export * from './payFund.factory'
export * from './payRequest.factory'
export * from './payRequestLog.factory'
export * from './payment.factory'
export * from './paymentApprover.factory'
export * from './paymentError.factory'
export * from './paymentMethod.factory'
export * from './paymentSource.factory'
export * from './paymentSource.factory'
export * from './paymentTerm.factory'
export * from './permissionGroup.factory'
export * from './procureOrderItem.factory'
export * from './punchOut.factory'
export * from './purchaseListItem.factory'
export * from './purchaseOrderItemSummary.factory'
export * from './purchaseOrderLineItem.factory'
export * from './purchaseOrderLineItemV2.factory'
export * from './purchaseorder.factory'
export * from './purchaseOrderWithUnreceivedItems.factory'
export * from './receiveLog.factory'
export * from './savedfilter.factory'
export * from './segmentAnalyticsMetadata.factory'
export * from './shippingMethod.factory'
export * from './shippingTerm.factory'
export * from './spendingCardAlert.factory'
export * from './spendingCardDeclinedTransaction.factory'
export * from './spendingCardStatement.factory'
export * from './ssoConnection.factory'
export * from './ssoProvider.factory'
export * from './stripeAccount.factory'
export * from './stripeAccountFund.factory'
export * from './stripeAddress.factory'
export * from './stripeBankAccount.factory'
export * from './syncResponse.factory'
export * from './tax.factory'
export * from './unbilledPurchaseOrder.factory'
export * from './unbilleditem.factory'
export * from './unitType.factory'
export * from './user.factory'
export * from './vendor.factory'
export * from './vendorApprovalGroup.factory'
export * from './vendorRequest.factory'

/*
 This file is for manually faked typed data to use as props for components.
 Would benefit from automatically generated data (faker based on TS interfaces)
*/

export const CUSTOM_FIELDS = {
  CHECKBOX: {
    id: 60,
    name: 'Custom checkbox',
    content_type: 27,
    default_value: '',
    is_required: false,
    field_choices: [],
    field_type: CustomFieldTypes.CHECKBOX,
    field_label: 'Boolean',
    is_active: true,
  },
  DATE: {
    id: 62,
    name: 'custom date',
    content_type: 27,
    default_value: '',
    is_required: true,
    field_choices: [],
    field_type: CustomFieldTypes.DATE,
    field_label: 'Date',
    is_active: true,
  },
  DROPDOWN: {
    id: 58,
    name: 'custom',
    content_type: 27,
    default_value: '',
    is_required: true,
    field_choices: ['1', '2', '3', '4'],
    field_type: CustomFieldTypes.DROPDOWN,
    field_label: 'Dropdown Choices',
    is_active: true,
  },
  TEXT: {
    id: 56,
    name: 'custom text1',
    content_type: 27,
    default_value: '',
    is_required: false,
    field_choices: [],
    field_type: CustomFieldTypes.TEXT,
    field_label: 'Text',
    is_active: true,
  },
} as { [key in keyof typeof CustomFieldTypes]: CustomField }

export const SINGLE_DEPARTMENT: Department = {
  id: 190,
  branch: {
    id: 6,
    name: 'Luettgen and Sons',
    headquarter: false,
  },
  external_id: '',
  name: 'Upload Department 2',
  active: true,
}

export const generateCsvMockSampleData = (
  fields: string[],
  numRows: number = 10
): ImporterSampleData => {
  const sampleData = {
    rows: [
      fields,
      ...new Array(numRows).fill(new Array(fields.length).fill('value')),
    ],
    columns: {},
    number_of_rows: numRows,
    number_of_columns: fields.length,
    number_of_comments: 0,
  }

  const columns = {}

  fields.map((field, index) => {
    columns[index] = [field, ...new Array(numRows).fill('value')]
  })

  sampleData.columns = columns

  return sampleData
}
